import api, { API_URL } from './api';

// Get token from localStorage
const getToken = () => {
  return localStorage.getItem('adminToken');
};

// Set token in localStorage
const setToken = (token) => {
  localStorage.setItem('adminToken', token);
  return token;
};

// Remove token from localStorage
const removeToken = () => {
  localStorage.removeItem('adminToken');
};

// Login
export const login = async (username, password) => {
  try {
    const response = await api.post('/api/admin/login', { username, password });
    if (response.data.token) {
      setToken(response.data.token);
    }
    return response.data;
  } catch (error) {
    // Better error handling
    if (error.response) {
      // Server responded with error status
      throw error.response.data || { error: error.response.statusText || 'Login failed' };
    } else if (error.request) {
      // Request made but no response received
      throw { error: 'Cannot connect to server. Please make sure the backend server is running on port 5001.' };
    } else {
      // Something else happened
      throw { error: error.message || 'Login failed' };
    }
  }
};

// Logout
export const logout = () => {
  removeToken();
  window.location.href = '/admin/login';
};

// Verify token
export const verifyToken = async () => {
  try {
    const response = await api.get('/api/admin/verify');
    return response.data.success;
  } catch (error) {
    return false;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!getToken();
};

// Get dashboard stats
export const getStats = async () => {
  const response = await api.get('/api/admin/stats');
  return response.data;
};

// Get all quotes
export const getQuotes = async (params = {}) => {
  const response = await api.get('/api/admin/quotes', { params });
  return response.data;
};

// Get single quote
export const getQuote = async (id) => {
  const response = await api.get(`/api/admin/quotes/${id}`);
  return response.data;
};

// Update quote
export const updateQuote = async (id, data) => {
  const response = await api.patch(`/api/admin/quotes/${id}`, data);
  return response.data;
};

// Delete quote
export const deleteQuote = async (id) => {
  const response = await api.delete(`/api/admin/quotes/${id}`);
  return response.data;
};

// Get all contacts
export const getContacts = async (params = {}) => {
  const response = await api.get('/api/admin/contacts', { params });
  return response.data;
};

// Get single contact
export const getContact = async (id) => {
  const response = await api.get(`/api/admin/contacts/${id}`);
  return response.data;
};

// Update contact
export const updateContact = async (id, data) => {
  const response = await api.patch(`/api/admin/contacts/${id}`, data);
  return response.data;
};

// Delete contact
export const deleteContact = async (id) => {
  const response = await api.delete(`/api/admin/contacts/${id}`);
  return response.data;
};

// Get all careers
export const getCareers = async (params = {}) => {
  const response = await api.get('/api/admin/careers', { params });
  return response.data;
};

// Get single career
export const getCareer = async (id) => {
  const response = await api.get(`/api/admin/careers/${id}`);
  return response.data;
};

// Update career
export const updateCareer = async (id, data) => {
  const response = await api.patch(`/api/admin/careers/${id}`, data);
  return response.data;
};

// Delete career
export const deleteCareer = async (id) => {
  const response = await api.delete(`/api/admin/careers/${id}`);
  return response.data;
};

export default {
  login,
  logout,
  verifyToken,
  isAuthenticated,
  getStats,
  getQuotes,
  getQuote,
  updateQuote,
  deleteQuote,
  getContacts,
  getContact,
  updateContact,
  deleteContact,
  getCareers,
  getCareer,
  updateCareer,
  deleteCareer
};

